// ─── Audio Service ─────────────────────────────────────────────────────────────
// Single source of truth for all app sounds.
// To swap a sound file or tune volume, change it here — nowhere else.

type SoundEvent = "order_placed" | "order_exit" | "notification"

const SOUNDS: Record<SoundEvent, { src: string; volume: number }> = {
  order_placed: { src: "/sounds/success-coin.mp3", volume: 0.9 },
  order_exit: { src: "/sounds/success-coin.mp3", volume: 0.9 },
  notification: { src: "/sounds/success-coin.mp3", volume: 0.9 },
}

export function playSound(event: SoundEvent): void {
  const config = SOUNDS[event]
  if (!config) return
  try {
    const audio = new Audio(config.src)
    audio.volume = config.volume
    audio.play().catch(() => { /* ignore autoplay restrictions */ })
  } catch { /* ignore */ }
}
